// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2TlHN","inputDescription":"styles_inputDescription__1Cb3h"};